import Container from "./pages/container";
// import "./assets/styles/styles.scss";
import { useEffect, useState } from "react";
import { Backdrop, Box, Modal } from "@mui/material";
import SignalWifiConnectedNoInternet4Icon from "@mui/icons-material/SignalWifiConnectedNoInternet4";
import useNetworkCheck from "./hooks/useNetworkCheck";
import "./App.css";

function App() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "280px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "24px",
    "&:active": {
      outline: "none",
    },
    "&:focus": {
      outline: "none",
    },
    zIndex: 2000,
  };
  const { isOnline } = useNetworkCheck();
  const [state, setState] = useState();
  const pathName = [
    "/jioimmerse-android/licenses",
    "/jioimmerse-ios/licenses",
    "/jioimmerse-android/terms-and-conditions",
    "/jioimmerse-ios/terms-and-conditions",
    "/jioimmerse-android/privacy-policy",
    "/jioimmerse-ios/privacy-policy",
  ];
  useEffect(() => {
    if (
      window.location.pathname &&
      pathName?.includes(window.location.pathname)
    ) {
      setState(true);
    } else {
      setState(false);
    }
  }, [window.location.pathname]);
  return (
    <div className="App">
      <Container />
      <Backdrop sx={{ color: "#fff", zIndex: 1 }} open={!isOnline && state}>
        {" "}
        <Modal
          open={!isOnline && state}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div>
              <span className="no-internet-heading">
                <SignalWifiConnectedNoInternet4Icon fontSize="large" /> No
                Internet Connection
              </span>
              <p className="no-internet-content">
                Please ensure you are connected to an active internet connection
              </p>
            </div>
          </Box>
        </Modal>
      </Backdrop>
    </div>
  );
}

export default App;
